import { Component, OnInit } from '@angular/core';
import { DocumentReader } from 'src/app/modules/core/store/models';
import * as fromAuth from 'src/app/modules/authentication/store/auth';
import { UserApiService } from 'src/app/modules/management/store/users';
import { UserProfileApiService, UserProfile } from 'src/app/modules/core/store/user-profile';
import { Store } from '@ngrx/store';
import { User } from 'src/app/modules/management/store/users/user.model';
import { Subject, Observable, of } from 'rxjs';
import { catchError, debounceTime, map, switchMap, take, takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-user-cell',
    templateUrl: './user-cell.component.html',
    styleUrls: ['./user-cell.component.scss'],
    standalone: false
})
export class UserCellComponent implements OnInit {
  displayName: any;
  emailAddress: string;
  profilePhotoUrl: string;
  organizationUId: string;
  userProfileUId: string;

  constructor(private userApi: UserProfileApiService,
    private store: Store<fromAuth.State>) {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;

    this.organizationUId = params.organizationUId;

    const field = params.schemaField;
    const reader = new DocumentReader(document);

    this.userProfileUId = !!params.data ? reader.getFieldValue(field.systemName) : params.value;

    const nameFieldName = params.nameFieldName ?? `${field.systemName}_name`;
    const emailFieldName = params.emailFieldName ?? `${field.systemName}_email`;

    this.displayName = reader.getFieldValue(nameFieldName);

    this.emailAddress = reader.getFieldValue(emailFieldName);
  }
}
